import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import logo from '../../../assets/images/tekstas-logo.svg';
import contactService from '../../../services/contactService';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  const [contactInfo, setContactInfo] = useState({
    address: '',
    addressLink: '',
    phone: '',
    email: '',
    hours: { weekday: '', weekend: '' }
  });

  useEffect(() => {
    const loadContactInfo = async () => {
      try {
        const data = await contactService.getContactInfo();
        
        // Handle both old and new address formats
        let address = '';
        let addressLink = '';
        
        if (typeof data.address === 'string') {
          // New format
          address = data.address;
          addressLink = data.addressLink || '';
        } else if (data.address && typeof data.address === 'object') {
          // Old format - convert to string
          const street = data.address.street || '';
          const city = data.address.city || '';
          address = street && city ? `${street}, ${city}` : street || city;
          addressLink = data.addressLink || '';
        }
        
        setContactInfo({
          address,
          addressLink,
          phone: data.phone || '',
          email: data.email || '',
          hours: data.hours || { weekday: '', weekend: '' }
        });
      } catch (error) {
        console.error('Failed to load contact info:', error);
      }
    };
    
    loadContactInfo();
  }, []);


  
  return (
    <footer className="footer">
      <Container>
        <Row className="py-5">
          <Col md={4} className="mb-4 mb-md-0">
            <Link to="/" className="footer-logo">
              <img
                src={logo}
                alt="Tekstas Logo"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </Link>
            <p className="mt-3">{t("footer.description")}</p>
          </Col>
          <Col md={{ span: 4, offset: 1 }} className="mb-4 mb-md-0">
            <h5>{t("footer.quick_links")}</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/">{t("nav.home")}</Link>
              </li>
              <li>
                <Link to="/exhibitions">{t("nav.exhibitions")}</Link>
              </li>
              <li>
                <Link to="#about">{t("footer.about")}</Link>
              </li>
              <li>
                <Link to="/careers">{t("footer.careers")}</Link>
              </li>
              <li>
                <Link to="/contact">{t("nav.contact")}</Link>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4 mb-md-0">
            <h5>{t("footer.contact")}</h5>
            <ul className="list-unstyled">
              {contactInfo.email && (
                <li className="d-flex align-items-center mb-2">
                  <Mail size={16} className="me-2 text-white" />
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="text-white text-decoration-none"
                  >
                    {contactInfo.email}
                  </a>
                </li>
              )}
              {contactInfo.phone && (
                <li className="d-flex align-items-center mb-2">
                  <Phone size={16} className="me-2 text-white" />
                  <a
                    href={`tel:${contactInfo.phone}`}
                    className="text-white text-decoration-none"
                  >
                    {contactInfo.phone}
                  </a>
                </li>
              )}
              {contactInfo.address && (
                <li className="d-flex align-items-center mb-2">
                  <MapPin size={16} className="me-2 text-white" />
                  {contactInfo.addressLink ? (
                    <a
                      href={contactInfo.addressLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-decoration-none"
                    >
                      {contactInfo.address}
                    </a>
                  ) : (
                    <span>{contactInfo.address}</span>
                  )}
                </li>
              )}
            </ul>
          </Col>
          {/* <Col md={2}>
            <h5>{t('footer.follow_us')}</h5>
            <div className="social-links">
              <a href="#" className="me-3 text-white">
                <Linkedin size={20} />
              </a>
              <a href="#" className="me-3 text-white">
                <Facebook size={20} />
              </a>
              <a href="#" className="me-3 text-white">
                <Instagram size={20} />
              </a>
            </div>
          </Col> */}
        </Row>
      </Container>
      <div className="footer-bottom">
        <Container>
          <p className="text-center mb-0">{t("footer.copyright")}</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;